const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/clients.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/clients")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});